import { render, staticRenderFns } from "./ProgramListItems.vue?vue&type=template&id=96bef8e4&scoped=true"
import script from "./ProgramListItems.vue?vue&type=script&lang=js"
export * from "./ProgramListItems.vue?vue&type=script&lang=js"
import style0 from "./ProgramListItems.vue?vue&type=style&index=0&id=96bef8e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96bef8e4",
  null
  
)

export default component.exports